module.exports = __webpack_public_path__ + "img/technology-17.f5091319.png";